var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 10.3998H6.375C6.168 10.3998 6 10.2214 6 9.99983C6 9.77823 6 2.22076 6 1.99997C6 1.77917 6.168 1.59998 6.375 1.59998H11.625C11.832 1.59998 12 1.77917 12 1.99997V9.99983C12 10.2214 11.832 10.3998 11.625 10.3998Z",
    fill: "#ECEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 3.99969H6.375C6.168 3.99969 6 3.8213 6 3.5997C6 3.3781 6.168 3.19971 6.375 3.19971H10.125C10.332 3.19971 10.5 3.3789 10.5 3.5997C10.5 3.8205 10.332 3.99969 10.125 3.99969Z",
    fill: "#1976D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 5.59967H6.375C6.168 5.59967 6 5.42127 6 5.19968C6 4.97808 6.168 4.79968 6.375 4.79968H10.125C10.332 4.79968 10.5 4.97888 10.5 5.19968C10.5 5.42047 10.332 5.59967 10.125 5.59967Z",
    fill: "#1976D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 7.19964H6.375C6.168 7.19964 6 7.02125 6 6.79965C6 6.57806 6.168 6.39966 6.375 6.39966H10.125C10.332 6.39966 10.5 6.57886 10.5 6.79965C10.5 7.02045 10.332 7.19964 10.125 7.19964Z",
    fill: "#1976D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 8.79962H6.375C6.168 8.79962 6 8.62122 6 8.39963C6 8.17803 6.168 7.99963 6.375 7.99963H10.125C10.332 7.99963 10.5 8.17883 10.5 8.39963C10.5 8.62042 10.332 8.79962 10.125 8.79962Z",
    fill: "#1976D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61427 0.0930109C6.52877 0.0162122 6.41402 -0.0157872 6.30602 0.00741241L0.306001 1.20739C0.129 1.24259 0 1.40819 0 1.60018V10.4C0 10.592 0.12825 10.7576 0.306001 10.7928L6.30602 11.9928C6.32927 11.9976 6.35177 12 6.37502 12C6.46202 12 6.54677 11.968 6.61427 11.908C6.70052 11.832 6.75002 11.7192 6.75002 11.6V0.400205C6.75002 0.281008 6.70052 0.16901 6.61427 0.0930109Z",
    fill: "#1565C0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87282 8.04527C4.85332 8.22847 4.71832 8.37487 4.54657 8.39727C4.53082 8.39967 4.51582 8.40047 4.50007 8.40047C4.34557 8.40047 4.20457 8.29807 4.14907 8.14127L3.37506 5.93971L2.60106 8.14127C2.54106 8.31247 2.38356 8.41726 2.20956 8.39806C2.03931 8.37887 1.90281 8.23807 1.87881 8.05647L1.50381 5.25652C1.47456 5.03892 1.61706 4.83573 1.82181 4.80453C2.02731 4.77253 2.21706 4.92533 2.24631 5.14372L2.41356 6.3949L3.02331 4.65973C3.13281 4.34774 3.61581 4.34774 3.72606 4.65973L4.30057 6.2933L4.50232 4.35574C4.52557 4.13654 4.71607 3.97894 4.91632 4.00214C5.12257 4.02774 5.27032 4.22534 5.24782 4.44454L4.87282 8.04527Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/Word.8b3d71f1359d2c8324567665b787f93f.svg";
export { ForwardRef as ReactComponent };